import React from 'react';
import './EventHighlight.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

// Icone SVG a linea (stile Lucide), colorate via CSS con currentColor
const icons = {
  trophy: (
    <>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </>
  ),
  music: (
    <>
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </>
  ),
  mic: (
    <>
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <path d="M12 19v3" />
    </>
  ),
  ticket: (
    <>
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
      <path d="M13 5v2" />
      <path d="M13 11v2" />
      <path d="M13 17v2" />
    </>
  ),
  kids: (
    <>
      <path d="M9 12h.01" />
      <path d="M15 12h.01" />
      <path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" />
      <path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1" />
    </>
  ),
  bed: (
    <>
      <path d="M2 4v16" />
      <path d="M2 8h18a2 2 0 0 1 2 2v10" />
      <path d="M2 17h20" />
      <path d="M6 8v9" />
    </>
  ),
};

const highlights = [
  {
    icon: 'trophy',
    title: 'Primo Premio Lotteria',
    description: 'Un fantastico weekend per 2 persone! Non perdere l\'occasione di vincere!',
  },
  {
    icon: 'music',
    title: 'Musica dal Vivo – Sabato e Domenica',
    description: 'Performance emozionanti per tutto il weekend.',
  },
  {
    icon: 'mic',
    title: 'Contest Musicale – Sabato',
    description: 'Talenti emergenti si sfidano sul palco: vieni a scoprire chi conquisterà il pubblico!',
  },
  {
    icon: 'ticket',
    title: 'Estrazione Lotteria',
    description: 'Scopri se la fortuna è dalla tua parte e porta a casa un premio incredibile!',
  },
  {
    icon: 'kids',
    title: 'Area Giochi per Bambini',
    description: 'Divertimento garantito anche per i più piccoli, con attività a loro dedicate.',
  },
  {
    icon: 'bed',
    title: 'Possibilità di dormire in loco',
    description: 'Possibilità di solo pernottamento alla Locanda Ferandi a soli 55€ a camera, prenotando entro fine agosto',
  }
];

const EventHighlight = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <section className="event-section">
      <h1 className="event-title">🎉 Grande Evento del Weekend! 🎉</h1>
      <div className="event-list">
        {highlights.map(({ icon, title, description }, index) => (
          <article
            key={title}
            className="event-card"
            data-aos="fade-up"
            data-aos-delay={(index % 2) * 100}
          >
            <div className="event-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                {icons[icon]}
              </svg>
            </div>
            <div className="event-content">
              <h2 className="event-subtitle">{title}</h2>
              <p className="event-description">{description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default EventHighlight;
